(function () {
  'use strict';

	  /* @ngdoc object
	   * @name crewProfile
	   * @description
	   *
	   */
	  angular
	    .module('crewProfile', [
	      'ui.router'
	    ]).config([
	      'panelsProvider',
	      function (panelsProvider) {
	          //Configure Slide in Panels
	          panelsProvider.add(
	              {
	                  id : 'crewing.right.panel',
	                  position: 'right',
	                  size: '600px',
	                  templateUrl: 'crewing/views/crewing-right-panel.tpl.html',
	                  controller: 'CrewingRightPanelCtrl'
	              }
	          );
	      }]);
	}());

